"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipTrendsChartDataPointSchema = exports.MembershipTrendsSnapshotSchema = exports.MembershipTrendsSnapshotBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
exports.MembershipTrendsSnapshotBaseSchema = zod_1.z.object({
    snapshotDate: zod_1.z.coerce.date(), // First day of month (e.g., 2024-01-01)
    expiredCount: zod_1.z.number(), // Members whose membership expired naturally this month (no renewal, no conversion)
    convertedCount: zod_1.z.number().default(0), // Members manually converted to non-member by admin this month
    newCount: zod_1.z.number(), // New members (first-ever membership started this month)
    renewedCount: zod_1.z.number(), // Members who renewed (had prior membership)
    netChange: zod_1.z.number(), // (new + renewed) - (expired + converted)
});
exports.MembershipTrendsSnapshotSchema = exports.MembershipTrendsSnapshotBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
// Chart data point for frontend consumption
exports.MembershipTrendsChartDataPointSchema = zod_1.z.object({
    date: zod_1.z.string(), // ISO date string
    expiredCount: zod_1.z.number(),
    convertedCount: zod_1.z.number(),
    newCount: zod_1.z.number(),
    renewedCount: zod_1.z.number(),
    netChange: zod_1.z.number(),
});
//# sourceMappingURL=MembershipTrendsSnapshot.js.map